import React from "react"
import { Stack } from "@shopify/polaris"
import { useTranslation } from "react-i18next"
import CreateReportButtonReportAtom from "views/atoms/reports/table/buttons/CreateReportButtonReportAtom"
import PropTypes from "prop-types"

const AddButtonEmptyTableReportMolecule = ({ viewerOnly = false }) => {
  const { t } = useTranslation()

  return (
    <tr key={"0"}>
      <td colSpan="8">
        <Stack distribution="center" alignment="center" spacing="loose">
          <p>{t("share:content.reports_table.empty")}</p>
          {!viewerOnly && <CreateReportButtonReportAtom />}
        </Stack>
      </td>
    </tr>
  )
}

AddButtonEmptyTableReportMolecule.propTypes = {
  viewerOnly: PropTypes.bool,
}

AddButtonEmptyTableReportMolecule.defaultProps = {
  viewerOnly: false,
}

export default AddButtonEmptyTableReportMolecule
